var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "complete",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm4.457-15.923l-6.724 6.75-2.48-2.48a.243.243 0 00-.205-.103.318.318 0 00-.23.103l-.716.716a.318.318 0 00-.102.23c0 .085.034.153.102.204l3.4 3.426a.374.374 0 00.231.077.276.276 0 00.204-.077l7.671-7.67a.318.318 0 00.102-.23.243.243 0 00-.102-.205l-.716-.741a.374.374 0 00-.23-.077.276.276 0 00-.205.077z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalComplete);
export default __webpack_public_path__ + "static/media/goal_complete.9896898d.svg";
export { ForwardRef as ReactComponent };